

import { useOneSignal } from '../hooks/use-onesignal';

interface OneSignalProviderProps {
  children: React.ReactNode;
}

export function OneSignalProvider({ children }: OneSignalProviderProps) {
  useOneSignal();
  
  return <>{children}</>;
}